/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodLookRight = createReactComponent("outline", "mood-look-right", "IconMoodLookRight", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M15 9h-.01", "key": "svg-1" }], ["path", { "d": "M20 15h-4", "key": "svg-2" }]]);

export { IconMoodLookRight as default };
//# sourceMappingURL=IconMoodLookRight.mjs.map
